var map = {
	"./_MG_2879.jpg": 68094,
	"./_MG_2886.jpg": 63957,
	"./_MG_2889.jpg": 24907,
	"./_MG_2903.jpg": 46887,
	"./_MG_2907.jpg": 66677,
	"./_MG_2927.jpg": 78445,
	"./_MG_2941.jpg": 75500,
	"./_MG_2958.jpg": 57672,
	"./_MG_3023.jpg": 33372
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 76844;
module.exports = webpackAsyncContext;